import { openCalendly } from "@/lib/calendly";

/**
 * Reusable Calendly trigger. Accepts any button styling via className/children.
 * Usage:
 *   <CalendlyButton className="btn-primary">Book consultation</CalendlyButton>
 */
export default function CalendlyButton({
  children,
  className = "",
  "data-testid": testId = "calendly-trigger",
  url,
  onClick,
  ...rest
}) {
  const handle = (e) => {
    e?.preventDefault?.();
    openCalendly({ url });
    onClick?.(e);
  };
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={handle}
      className={className}
      {...rest}
    >
      {children}
    </button>
  );
}
